import './App.css';
import { Routes, Route } from "react-router-dom";
import  Homepages   from "../src/Pages/Homepages";
import  AboutUsPage   from "../src/components/AboutUsPage/AboutUsPage";
import  Contact   from "../src/components/ContactPage/ContactPage";
import  ScrollToTop  from "../src/components/Comman/ScrollToTop";
import  Services  from "../src/components/Services/Services";
import  Products  from "../src/components/Products/Products";
import  FloatingWhatsApp  from "../src/components/Comman/FloatingWhatsApp";

import  AddMachinePage  from "../src/components/Admin/productsPage/AddMachinePage";
import  PrivacyPolicy  from "../src/components/Terms/PrivacyPolicy";
import  TermsofService  from "../src/components/Terms/TermsofService";
import  Support  from "../src/components/Terms/Support";
import  MachinesPage  from "../src/components/Admin/productsPage/MachinesPage";
import  MachineDetails  from "../src/components/Admin/productsPage/MachineDetails";

// import  QuotationEditor  from "../src/components/Admin/QuotationEditor/QuotationEditor";

function App() {
  return (
     <>
     <ScrollToTop />
      <Routes>
        <Route path="/" element={<Homepages />} />
        <Route path="/about" element={<AboutUsPage />} />
        <Route path="/contact" element={<Contact />} />
        <Route path="/services" element={<Services />} />
        <Route path="/products" element={<Products />} />
        <Route path="/Catloge" element={<MachinesPage />} />
        <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
        <Route path="/TermsofService" element={<TermsofService />} />
        <Route path="/Support" element={<Support />} />
        <Route path="/Nexora/Admin/@catloge" element={<AddMachinePage />} />
        <Route path="/MachineDetails/:categoryId/:machineId" element={<MachineDetails />} />
        {/* <Route path="/QuotationEditor" element={<QuotationEditor />} /> */}
        {/* <Route path="/QuotationEditor" element={<QuotationEditor />} /> */}
      </Routes>
      <FloatingWhatsApp />
    </>
  );
}

export default App;
